$(function() {
    var nav_pos = $(".page-nav").offset().top;
var nav_height = $(".page-nav").outerHeight();
$(window).scroll(function () {
    if ($(this).scrollTop() > nav_pos) {
        $("body").css("padding-top", nav_height);
        $(".page-nav").addClass("is-fixed");
    } else {
        $("body").css("padding-top", 0);
        $(".page-nav").removeClass("is-fixed");
    }
});
});



$(function(){
  var swiper = new Swiper('.swiper-container-sale04', {
    navigation: { 
      nextEl: '.swiper-button-next-sale04',
      prevEl: '.swiper-button-prev-sale04',
    },
    pagination: {
    el: '.swiper-pagination04',
    clickable: true,
  },
    loop: true,
    speed: 3000, // ループの時間
    /*allowTouchMove: false, */// スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
  },
    /*disabledClass: '.swiper-button-disabled',*/
    slidesPerView: 1,
    slidesPerView: 1.14, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 2.4,
        spaceBetween: 20,
			}
		}
	});
  });